import React from 'react';

const UserDataContext = React.createContext({isUserVerified: false, isUserSubmitted: false})

export default UserDataContext;